var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    zoomAndPan: "magnify",
    viewBox: "0 0 810 809.999993",
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.082331, 0, 0, 0.89543, 3.60387, 362.593653)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 385.717774 251.245611 C 385.717774 251.245611 419.603697 349.683871 390.709171 437.4778 ",
    stroke: "#b15282",
    strokeWidth: 10.35,
    strokeOpacity: 1,
    strokeMiterlimit: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(1.977333, -0.262712, 0.279545, 1.858254, -474.990621, -125.723998)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 391.042284 439.274592 C 391.042284 439.274592 489.656511 438.083182 509.798015 405.083456 C 529.941455 372.084004 490.010255 354.170797 454.858133 367.151038 C 419.449428 380.227436 394.117781 411.511717 391.042284 439.274592 Z M 391.042284 439.274592 ",
    stroke: "#b15282",
    strokeWidth: 5.33,
    strokeOpacity: 1,
    strokeMiterlimit: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    transform: "matrix(-2.23261, 0.296631, 0.411281, 2.733861, 1113.409747, -729.090111)",
    fill: "none",
    strokeLinejoin: "round",
    d: "M 391.043439 439.274357 C 391.043439 439.274357 489.657372 438.083426 509.798337 405.083712 C 529.94076 372.082411 490.01082 354.170727 454.858315 367.150873 C 419.448888 380.227481 394.117364 411.511383 391.043439 439.274357 Z M 391.043439 439.274357 ",
    stroke: "#b15282",
    strokeWidth: 3.89,
    strokeOpacity: 1,
    strokeMiterlimit: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListy);
export default __webpack_public_path__ + "static/media/listy.36131a92452c41f96079c007d8b61305.svg";
export { ForwardRef as ReactComponent };